export default __webpack_public_path__ + "static/media/player_icon.b05f797b.svg";